module.exports = __webpack_public_path__ + "static/media/get-paid-listing.1e39ea33.svg";